/**
 * The store offer a subscription was bought with, in words (#1849). Android waitlist members should be on the Play
 * offer `waitlist-50-first-year`; one bought from the regular paywall has `free-trial-14d` and pays full price after
 * the trial (#1813).
 */
export const WAITLIST_OFFER_CODE = "waitlist-50-first-year";

export function offerText(code) {
  if (!code) return null;
  if (code === WAITLIST_OFFER_CODE) return "50% waitlist offer";
  if (code === "free-trial-14d") return "Regular price (free-trial-14d)";
  return code;
}

// RevenueCat's cancel reasons, in words. UNSUBSCRIBE, the customer turning auto-renew off, goes without saying.
const CANCEL_REASONS = {
  BILLING_ERROR: "payment failed",
  DEVELOPER_INITIATED: "cancelled by us",
  PRICE_INCREASE: "declined a price increase",
  CUSTOMER_SUPPORT: "refunded by store support",
  UNKNOWN: "reason unknown"
};

/**
 * Whether a running trial or subscription has auto-renew turned off (#2485): RevenueCat's last event is a
 * CANCELLATION and access lasts until the expiry. An UNCANCELLATION or RENEWAL after it replaces the event, so it
 * reads on again. Returns null when it renews, else `{ reason }`, the cancel reason in words or null.
 */
export function autoRenewOff(computed, event, rawPayload) {
  if (!computed?.is_active || event?.type !== "CANCELLATION") return null;
  const code = event.cancel_reason || rawPayload?.event?.cancel_reason || null;
  return { reason: code && code !== "UNSUBSCRIBE" ? (CANCEL_REASONS[code] || code) : null };
}
